import Vue from 'vue'
import Router from 'vue-router'
import Default from '@/components/Default'
import ProjectOverview from '@/components/ProjectOverview'
import ProjectDetail from '@/components/ProjectDetail'


Vue.use(Router)

export default new Router({

  routes: [{
      path: '/',
      name: 'home',
      component: Default 
    },
    {
      path: '/galerie',
      name: 'galerie',
      component: Default
    },
    {
      path: '/aufnahme',
      name: 'aufnahme',
      component: ProjectOverview
    },
    {
      path: '/aufnahme/:slugname?',
      name: 'aufnahme',
      component: ProjectDetail
    },
    {
      path: '/app',
      name: 'app',
      component: Default
    },
    {
      path: '/spenden',
      name: 'spenden',
      component: Default
    }

  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js